import {
  formControlVariants,
  type FormControlVariantProps,
} from '@/shared/components/ui/form-control-styles';
import { cn } from '@/shared/lib/utils';
import * as React from 'react';

export interface TextareaProps
  extends React.ComponentProps<'textarea'>,
    FormControlVariantProps {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, size = 'md', tone, ...props }, ref) => (
    <textarea
      className={cn(
        formControlVariants({ variant, size, tone }),
        'min-h-[80px] items-start resize-y',
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';

export { Textarea };
